import mitt from 'mitt'
import Events from 'core/emitter/events'
import { Message } from 'core/emitter/events/message'
import { ElNotification } from 'element-plus'

const emitter = mitt<Events>()

emitter.on('notify', (message: Message) => {
  ElNotification({
    message: message.message,
    type: message.type,
  })
})

export default emitter
